/**
 * Removes pasted <style> blocks from collection hero copy (Shopify admin → collection description).
 * Those tags inject global rules (e.g. bare `a { }`) that leak across the whole storefront.
 * Scoped to .image-banner__text where {{ collection.description }} is rendered.
 */
(function stripCollectionDescriptionStyleTags() {
  function removeStyleTags() {
    document.querySelectorAll('.image-banner__text style').forEach(function (node) {
      node.remove();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeStyleTags);
  } else {
    removeStyleTags();
  }
})();
